import { useContext } from 'react'

import { AuthContext } from 'features/auth/auth-context'
import { useProjectStore } from 'features/project/store'

/**
 * Hubs locked against member management, listed in code. The backend keeps
 * the same uuids and refuses adding, re-roling and removing members for
 * non-staff on these hubs; change both lists together. This list only
 * decides what the UI offers, and the admin Feature flags page shows it.
 */
export const LOCKED_HUBS: ReadonlyArray<{ uuid: string; name: string }> = [
  { uuid: '3337cf2c-e162-4e8b-9855-3ada477b6c99', name: 'Olly (2189)' },
  {
    uuid: 'f6d687c8-fd20-4075-9b6b-06280b42db38',
    name: 'Olly - Ratings & Reviews (2085)',
  },
  {
    uuid: 'abb3c056-cc6a-489f-bcc3-3b4b0d867449',
    name: 'Olly - Zendesk (2154)',
  },
  {
    uuid: '039c585d-89df-4efb-b145-9c7ee160c9c6',
    name: 'Olly - Social (3537)',
  },
  {
    uuid: 'bf1282ad-87a1-4995-87bf-33688e5b14ab',
    name: 'Olly - Reddit (4463)',
  },
]

const LOCKED_HUB_UUIDS: ReadonlySet<string> = new Set(
  LOCKED_HUBS.map((hub) => hub.uuid),
)

/** Whether the active hub is locked for the current user. Yogi staff are exempt. */
export function useMemberManagementLock(): { isLocked: boolean } {
  const { userDetails } = useContext(AuthContext)
  const projectId = useProjectStore((state) => state.projectId)
  const isHubLocked = !!projectId && LOCKED_HUB_UUIDS.has(projectId)
  return { isLocked: isHubLocked && !userDetails?.yogi_user }
}
